import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import { toggleLoading } from '../../Redux/Actions/Loading';

const CSVColConfigs = ({ inputs, onToggleLoading }) => {
  const [configs, setConfigs] = useState(inputs);

  useEffect(() => {
    setConfigs(inputs);
  }, [inputs]);

  const save = () => {
    onToggleLoading();
    axios
      .put('/api/v1/configs/all', {
        object: configs,
      })
      .then(() => {
        onToggleLoading();
      })
      .catch(e => {
        onToggleLoading();
        toast.error(`Impossible d'obtenir toutes les configurations`);
      });
  };

  return (
    <div className="content-box">
      <h3 className="content-box-header bg-default">
        <i className="glyph-icon icon-cog" />
        Configuration colonnes CSV
      </h3>
      <div className="content-box-wrapper">
        <div className="csv-rows">
          {Object.keys(configs).map(key => (
            <div key={key} className="form-group col-xs-3 col-md-3">
              <label className="control-label" htmlFor={key}>
                {configs[key].original}
              </label>
              <input
                id={key}
                value={configs[key].value}
                onChange={e =>
                  setConfigs({
                    ...configs,
                    [key]: { ...configs[key], value: e.target.value },
                  })
                }
                className="csv-input form-control"
              />
            </div>
          ))}
          <div className="csv-confirm">
            <button
              name="button"
              type="button"
              onClick={save}
              className="btn btn-primary"
            >
              Sauvegarder
            </button>
            <div className="success-msg" />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  onToggleLoading: () => dispatch(toggleLoading()),
});

export default connect(
  null,
  mapDispatchToProps,
)(CSVColConfigs);
